"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _drawerMainMenu = _interopRequireDefault(require("./../drawer-main-menu"));

require("./style/drawer-mobile.scss");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _wrapperContext = _interopRequireDefault(require("../../context/wrapper-context"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  transition: ease-in-out 0.2s;\n  width: 346px;\n  height: 100%;\n  overflow-x: hidden;\n  background-color: ", ";\n  position: fixed;\n  user-select: none;\n  z-index: 1000;\n  top: 64px;\n  transform: translate3d(", ", 0, 0);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DrawerBox = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.palette.white.main;
}, function (props) {
  return props.drawerHidden ? '-100%' : 0;
});
/**
 * Drawer - left side menu, that contains the main menu
 *
 * @class Drawer
 * @extends {Component}
 * @param menuItems - main menuItems that should be displayed
 * @param hidden - drawer is hidden boolean
 * @param toggleDrawer - toggle drawer func
 */


var DrawerMobile = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(DrawerMobile, _Component);

  var _super = _createSuper(DrawerMobile);

  function DrawerMobile() {
    (0, _classCallCheck2["default"])(this, DrawerMobile);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(DrawerMobile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isMobile = _this$props.isMobile,
          menuItems = _this$props.menuItems,
          toggleDrawer = _this$props.toggleDrawer,
          hidden = _this$props.hidden,
          userFullname = _this$props.userFullname,
          userEmail = _this$props.userEmail,
          toggleDrawerOnClick = _this$props.toggleDrawerOnClick;
      var isFreeAccount = this.context.isFreeAccount; // const classOfDrawer = this.props.hidden ? 'drawer-mobile hidden' : 'drawer-mobile'

      var name = userFullname || userEmail;
      var marginTop = Math.max(0, this.context.amountOfDetailBars - 1) * 64;
      return /*#__PURE__*/_react["default"].createElement(DrawerBox, {
        drawerHidden: hidden,
        className: "drawer-mobile",
        style: {
          marginTop: marginTop
        }
      }, /*#__PURE__*/_react["default"].createElement("div", null), name, /*#__PURE__*/_react["default"].createElement(_drawerMainMenu["default"], {
        isMobile: isMobile,
        toggleDrawerOnClick: toggleDrawerOnClick,
        hidden: hidden,
        menuItems: menuItems,
        toggleDrawer: toggleDrawer,
        isFreeAccount: isFreeAccount
      }));
    }
  }]);
  return DrawerMobile;
}(_react.Component);

DrawerMobile.contextType = _wrapperContext["default"];
DrawerMobile.propTypes = {
  isMobile: _propTypes["default"].bool.isRequired,
  toggleDrawerOnClick: _propTypes["default"].bool,
  menuItems: _propTypes["default"].array,
  hidden: _propTypes["default"].bool,
  toggleDrawer: _propTypes["default"].func,
  userFullname: _propTypes["default"].string,
  userEmail: _propTypes["default"].string // userColor: PropTypes.string,

};
DrawerMobile.defaultProps = {
  title: '',
  showRightButton: false
};
var _default = DrawerMobile;
exports["default"] = _default;